import React from 'react';
import { useParams } from 'react-router-dom';
import WhatsAppMessaging from '../../components/coaching/WhatsAppMessaging';
import { useRealtime } from '../../contexts/RealtimeContext';

const WhatsAppMessagingPage = () => {
  const { coachingId } = useParams();
  const { userProfile } = useRealtime();
  
  // Use coachingId from params or from user profile
  const activeCoachingId = coachingId || userProfile?.coachingId;
  const coachingName = userProfile?.coachingName || 'Coaching Center';

  console.log('WhatsAppMessagingPage - coachingId from params:', coachingId);
  console.log('WhatsAppMessagingPage - userProfile:', userProfile);
  console.log('WhatsAppMessagingPage - activeCoachingId:', activeCoachingId);
  console.log('WhatsAppMessagingPage - coachingName:', coachingName);

  if (!activeCoachingId) {
    return (
      <div className="max-w-7xl mx-auto p-6">
        <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4">
          <p className="text-yellow-800 dark:text-yellow-200">
            No coaching ID found. Please make sure you're accessing this page from the coaching admin dashboard.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto">
      <WhatsAppMessaging 
        coachingId={activeCoachingId} 
        coachingName={coachingName}
      />
    </div>
  );
};

export default WhatsAppMessagingPage;
